/*
 * Purpose: Sort integration proposals — free connections first
 * Last modified: 2026-06-28 | Agent
 * Completeness: 100
 */
import type {
  IntegrationDiscoveryProposal,
  IntegrationPricingTier,
} from '@/services/integrations/types';

const TIER_ORDER: Record<IntegrationPricingTier, number> = {
  free: 0,
  freemium: 1,
  unknown: 2,
  paid: 3,
};

export function resolveProposalPricingTier(
  proposal: IntegrationDiscoveryProposal
): IntegrationPricingTier {
  const tier =
    proposal.pricingTier ?? proposal.connector.discoveryMeta?.pricingTier ?? 'unknown';
  if (tier === 'free' || tier === 'freemium' || tier === 'paid') return tier;
  return 'unknown';
}

export function sortProposalsFreeFirst(
  proposals: IntegrationDiscoveryProposal[]
): IntegrationDiscoveryProposal[] {
  return [...proposals].sort(
    (a, b) =>
      TIER_ORDER[resolveProposalPricingTier(a)] - TIER_ORDER[resolveProposalPricingTier(b)]
  );
}

export function pricingTierLabel(tier: IntegrationPricingTier): string {
  switch (tier) {
    case 'free':
      return 'Free';
    case 'freemium':
      return 'Freemium';
    case 'paid':
      return 'Paid';
    default:
      return 'Pricing unknown';
  }
}
